import React, { useMemo } from 'react';
import isEmpty from 'lodash/isEmpty';
import Box from '@mui/material/Box';
import { useSelector } from 'react-redux';

import { useTypeOfSpinner } from 'src/hooks/spinner';
import { useTranslations } from 'src/hooks/translataions';
import { locals } from 'src/constants/locals';
import { requestSelectors } from 'src/store/requests/selectors';
import { ListOfKeysFilterAllData } from 'src/typings/filter';
import { useGetComplexStatuses } from 'src/hooks';
import { useStyles } from './styles';
import { IButtonBackSpinner } from './types';
import { BackChevronIcon } from './BackChevronIcon';

export const ButtonBackSpinner: React.FC<IButtonBackSpinner> = ({
  className,
}) => {
  const mainColor = useSelector(requestSelectors.app.getMainColors);
  const style = useStyles(mainColor);
  const { getTranslations } = useTranslations();
  const spinnerData = useSelector(requestSelectors.spinner.getSpinnerViewData);
  const { isMainSpinner, currentSpinner, handleBackToMainSpinner } = useTypeOfSpinner();
  const { statuses } = useGetComplexStatuses();
  const firstStatusColor = statuses[0]?.color;

  const houseName = useMemo(() => {
    if (currentSpinner && spinnerData?.house) {
      const houseData = spinnerData.house[currentSpinner['name-id']];
      if (houseData) {
        return houseData.additional_data[ListOfKeysFilterAllData.placementHouse];
      }
    }
    return '';
  }, [currentSpinner, spinnerData]);

  if (isEmpty(spinnerData?.complex)) {
    return null;
  }

  return (
    <Box className={`${style.breadcrumbsWrapper} ${className || ''}`}>
      {isMainSpinner ? (
        <Box className={style.chooseSegment}>
          <span className="active-text">
            {getTranslations(locals.appTranslations.appChooseHouseBreadcrumbs)}
          </span>
        </Box>
      ) : (
        <>
          <Box className={style.backSegment} onClick={handleBackToMainSpinner}>
            <Box className={style.iconWrapper}>
              <BackChevronIcon className={style.chevronIcon} />
            </Box>
            <span className="active-text">
              {getTranslations(locals.appTranslations.appAllHousesBreadcrumbs)}
            </span>
          </Box>
          <Box className={style.currentSegment}>
            <Box className={style.iconWrapper}>
              <span className={style.dot} style={firstStatusColor ? { backgroundColor: firstStatusColor } : undefined} />
            </Box>
            <span className="active-text">
              {`${getTranslations('placement.house')} ${houseName}`}
            </span>
          </Box>
        </>
      )}
    </Box>
  );
};
